import { render, staticRenderFns } from "./cModalAsign.vue?vue&type=template&id=37655902"
import script from "./cModalAsign.vue?vue&type=script&lang=js"
export * from "./cModalAsign.vue?vue&type=script&lang=js"
import style0 from "./cModalAsign.vue?vue&type=style&index=0&id=37655902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports